import './index.css'
import { ChevronLeft, ChevronRight, Plus, Download, CalendarDays } from 'lucide-react'
import type { TopbarProps } from '../../types'

export default function Topbar({
  active,
  month,
  year,
  annualYear,
  isCurrentMonth,
  onAdd,
  onPrevMonth,
  onNextMonth,
  onGoToCurrentMonth,
  onPrevYear,
  onNextYear,
}: TopbarProps) {
  if (active === 'admin') return null

  if (active === 'annual') {
    return (
      <header className="bc-topbar">
        <div className="bc-topbar__inner">
          <div className="bc-monthnav">
            <button className="bc-iconbtn" onClick={onPrevYear} aria-label="Ano anterior">
              <ChevronLeft size={18} />
            </button>
            <div className="bc-monthnav__label">
              <span className="bc-monthnav__month">Visão anual</span>
              <span className="bc-monthnav__year">{annualYear}</span>
            </div>
            <button className="bc-iconbtn" onClick={onNextYear} aria-label="Próximo ano">
              <ChevronRight size={18} />
            </button>
          </div>
          <div className="bc-topbar__actions">
            <button className="bc-btn bc-btn--ghost">
              <Download size={16} /><span>Exportar planilha</span>
            </button>
            <button className="bc-btn bc-btn--primary" onClick={onAdd}>
              <Plus size={16} /><span>Novo lançamento</span>
            </button>
          </div>
        </div>
      </header>
    )
  }

  return (
    <header className="bc-topbar">
      <div className="bc-topbar__inner">
        <div className="bc-monthnav">
          <button className="bc-iconbtn" onClick={onPrevMonth} aria-label="Mês anterior">
            <ChevronLeft size={18} />
          </button>
          <div className="bc-monthnav__label">
            <span className="bc-monthnav__month">{month}</span>
            <span className="bc-monthnav__year">{year}</span>
          </div>
          <button className="bc-iconbtn" onClick={onNextMonth} aria-label="Próximo mês">
            <ChevronRight size={18} />
          </button>
          <button
            className="bc-btn bc-btn--ghost bc-topbar__today"
            onClick={onGoToCurrentMonth}
            disabled={isCurrentMonth}
            aria-label="Voltar para o mês atual"
          >
            <CalendarDays size={16} />
            <span>Hoje</span>
          </button>
        </div>
        <div className="bc-topbar__actions">
          <button className="bc-btn bc-btn--primary" onClick={onAdd} data-tour="add-btn">
            <Plus size={16} /><span>Novo lançamento</span>
          </button>
        </div>
      </div>
    </header>
  )
}
